import { useBeaconScript } from 'client/hooks/useBeaconScript';
import { useDataLayerEvent, useResultUpdateEvent } from 'client/hooks/useEvents';
import useUpdateEvent from 'client/hooks/useUpdateEvent';
import React from 'react';

function Events() {
  useBeaconScript();
  useUpdateEvent();
  useResultUpdateEvent();
  useDataLayerEvent();
  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <></>;
}

export default React.memo(Events);
